import { USERNAMES } from '../../constants/sessionStorage';
import { retrieveFromSessionStorage } from './sessionStorageHelper';

export function getUsernames() {
  const usernames = retrieveFromSessionStorage(USERNAMES);
  const usernameOptions = usernames
    ? usernames.map((username) => ({
        label: username,
        value: username,
      }))
    : [];

  return usernameOptions;
}
